import { render } from "./ImportTag.vue?vue&type=template&id=513505ea"
import script from "./ImportTag.vue?vue&type=script&lang=js"
export * from "./ImportTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__